/**
 * Texts for footer
 */
export const footerText = {
    txtFAQs: 'FAQs',
    txtSupport: 'Support',
    txtUserTraining: 'User Training',
    txtNews: 'News',
    txtCamAPSLiberty: 'CamAPS Liberty',
    txtCareers: 'Careers',
    txtReviews: 'Stories',
    txtNotifications: 'Notifications',
    txtHistory: 'History',
    txtTrainingHtml: 'https://www.camdiabtraining.com/account-sign-in.html',
    txtTraining: 'Online training',
    txtClinic: 'CamAPS FX Clinic',
    terms: 'Terms and conditions',
    privacy: 'Privacy policy',
    accessibility: 'Accessibility Statement',
    txtFooterBottom: 'CamAPS, CamAPS Liberty and MealAssist are registered trademarks of CamDiab Ltd. ' +
        'Other trademarks are the property of their respective owners. No use of any CamDiab trademark, ' +
        'trade name, or trade dress in this site may be made without the prior written authorisation of CamDiab, ' +
        'except to identify the product or services of the company. The product images are for illustrative purposes only.',
    rightsReserved: 'CamDiab Ltd. All rights reserved.',

    statusPageFooterText: 'Status page',
    statusPageFooterLink: 'https://camdiabltd.statuspage.io/',

    sscpPageFooterText: 'CamAPS FX Safety Information (SSCP)',
    sscpPageFooterHtml: 'https://s3.eu-west-1.amazonaws.com/camdiab.user.manual/APCam-FX(FX)-D47_SSP_EN.pdf',
};
